const RecaptchaComponent = function () {
    let $currentContext = $();
    const moduleOptions = {
        siteKey: ""
    };

    const classMap = {
        recaptcha: ".js-recaptcha__control",
        error: ".js-recaptcha__error"
    };

    let $recaptcha, $error, $form;
    let widgetId;

    function showError() {
        $error.show();
    }

    function hideError() {
        $error.hide();
    }

    function createRecaptcha() {
        const id = $recaptcha.attr("id");

        widgetId = grecaptcha.render(id, {
            "sitekey": moduleOptions.siteKey,
            "theme": "light",
            "size": "normal",
            "callback": hideError,
            "expired-callback": showError,
            "error-callback": showError
        });
    }

    function handleFormSubmission(submissionEvent) {
        const gresponse = grecaptcha.getResponse(widgetId);
        if (!gresponse) {
            submissionEvent.preventDefault();
            $error.show();
        }
    }

    function initContext() {
        $recaptcha = $(classMap.recaptcha, $currentContext);
        $error = $(classMap.error, $currentContext);
        $form = $recaptcha.closest("form");
    }

    function bindEvents() {
        $form.on("submit", function (e) {
            handleFormSubmission(e);
        });
    }

    this.init = function (context, options) {
        $currentContext = context || $currentContext;
        $.extend(moduleOptions, options);

        initContext();
        bindEvents();
        createRecaptcha();
    };
};

Object.defineProperty(RecaptchaComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-recaptcha"
});

module.exports = RecaptchaComponent;
